import x from "./ghl-ui.es1167.js";
import u from "./ghl-ui.es1157.js";
const v = (l) => {
  const {
    primaryColor: t,
    borderRadius: e,
    lineHeight: c,
    fontSize: o,
    cardColor: d,
    textColor2: i,
    textColor1: n,
    dividerColor: a,
    fontWeightStrong: s,
    closeIconColor: m,
    closeIconColorHover: C,
    closeIconColorPressed: g,
    closeColorHover: b,
    closeColorPressed: f,
    modalColor: S,
    boxShadow1: h,
    popoverColor: p,
    actionColor: r
  } = l;
  return Object.assign(Object.assign({}, x), {
    lineHeight: c,
    color: d,
    colorModal: S,
    colorPopover: p,
    colorTarget: t,
    colorEmbedded: r,
    colorEmbeddedModal: r,
    colorEmbeddedPopover: r,
    textColor: i,
    titleTextColor: n,
    borderColor: a,
    actionColor: r,
    titleFontWeight: s,
    closeColorHover: b,
    closeColorPressed: f,
    closeBorderRadius: e,
    closeIconColor: m,
    closeIconColorHover: C,
    closeIconColorPressed: g,
    fontSizeSmall: o,
    fontSizeMedium: o,
    fontSizeLarge: o,
    fontSizeHuge: o,
    boxShadow: h,
    borderRadius: e
  });
}, z = {
  name: "Card",
  common: u,
  self: v
}, P = z;
export {
  P as default,
  v as self
};
